import React, { memo } from 'react';
import HmsVideo from '../local/hmsVideo';
const HMSRemoteVideo = ({ videoTrack, subscribeToVideo }) => {
    if (subscribeToVideo === false) {
        return null;
    }
    return React.createElement(HmsVideo, { videoTrack: videoTrack });
};
export default memo(HMSRemoteVideo);
//# sourceMappingURL=hmsRemoteVideo.js.map